import { render, staticRenderFns } from "./EditItineraryBlockModal.vue?vue&type=template&id=1fade8e2&"
import script from "./EditItineraryBlockModal.vue?vue&type=script&lang=js&"
export * from "./EditItineraryBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./EditItineraryBlockModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports